<template>
    <div>
      <!-- Top bar -->
      <div class="nav-bar-operations">
        <img src="@/assets/logogruas.png" alt="HomePage" @click="backMainPanel" class="logo-button" />
      </div>
      <div class="text-operations"></div>
  
      <!-- Header -->
      <div class="panel-head">
        <h3>Generación de reporte de Comisiones de Operador</h3>
        <img src="@/assets/filtros.png" alt="filtros" />
      </div>
  
      <!-- Filters (form => Enter submits) -->
      <form
        class="filters-card"
        @submit.prevent="handleSubmit"
        @keydown.enter.prevent="handleSubmit"
      >
        <!-- Fecha -->
        <div class="row">
          <label>Fecha</label>
          <input type="date" v-model="startDate" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }" />
          <span class="sep">al</span>
          <input type="date" v-model="endDate" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }" />
        </div>
  
        <!-- Número de orden -->
        <div class="row">
          <label for="note_number_start">Número de orden</label>
          <input id="note_number_start" type="text" v-model="noteNumberStart" placeholder="Inicio" />
          <span class="sep">al</span>
          <input id="note_number_end" type="text" v-model="noteNumberEnd" placeholder="Fin" />
        </div>
  
        <!-- Tipo de servicio -->
        <div class="row">
          <label for="type">Tipo de servicio</label>
          <select id="type" v-model="noteType" class="form-select">
            <option value="" disabled selected>Seleccione un tipo de servicio</option>
            <option value="Asistencia víal">Remolque</option>
            <option value="Auxilio víal">Auxilio vial</option>
            <option value="Lote">Lote</option>
            <option value="Montacargas">Montacargas</option>
            <option value="Industrial">Industrial</option>
          </select>
          <span class="sep"></span>
          <div class="cell"></div>
        </div>
  
        <!-- Nombre de operador -->
        <div class="row">
          <label for="operator_name">Nombre de operador</label>
          <input id="operator_name" type="text" v-model="operatorName" placeholder="Ingrese el nombre del operador" />
          <span class="sep"></span>
          <div class="cell"></div>
        </div>
  
        <!-- Número de operador -->
        <div class="row">
          <label for="operator_number_start">Número de operador</label>
          <input id="operator_number_start" type="text" v-model="operatorNumberStart" placeholder="Inicio" />
          <span class="sep">al</span>
          <input id="operator_number_end" type="text" v-model="operatorNumberEnd" placeholder="Fin" />
        </div>
  
        <!-- Actions -->
        <div class="row actions">
          <div class="cell span-4">
            <button type="submit" class="btn-submit-save" :disabled="isGeneratingReport">
              {{ isGeneratingReport ? 'Generando reporte...' : 'Generar reporte' }}
            </button>
          </div>
        </div>
      </form>
    </div>
  </template>
  
  <style scoped>
  /* Top bar (kept) */
  .nav-bar-operations {
    position: absolute; top: 0; left: 0; width: 100%; height: 10vh;
    background-color: #FFC434; z-index: 1000; margin: 0;
  }
  .logo-button { position: absolute; height: 90%; top: 50%; left: 50%; transform: translate(-50%, -50%); cursor: pointer; margin: 0; }
  .text-operations { margin-top: 10vh; width: 100%; height: 5vh; border-bottom: 1px solid #000; background: #fff; }
  
  .panel-head { margin: 10px 8px 6px; display: flex; align-items: center; gap: 8px; }
  .panel-head h3 { font-size: 1.15rem; margin: 0; }
  .panel-head img { width: 24px; height: 24px; }
  
  /* Filters card */
  .filters-card{
    --label-w: 200px;
    --ctrl-w: 360px;
    --sep-w: 22px;
    --gap: 8px;
    --h: 36px;
    --fs: 14px;
    --fs-small: 12px;
    --pad-x: 10px;
    --radius: 10px;
  
    margin: 10px 8px 16px;
    background: #fff;
    border: 1px solid #eee;
    border-radius: 12px;
    padding: 14px;
    box-shadow: 0 2px 10px rgba(0,0,0,.06);
    display: grid; gap: 10px;
  }
  .filters-card .row{
    display: grid;
    grid-template-columns: var(--label-w) var(--ctrl-w) var(--sep-w) var(--ctrl-w);
    align-items: center;
    gap: var(--gap);
  }
  .filters-card .row.actions { grid-template-columns: 1fr; }
  .filters-card .row-rel { position: relative; }
  .filters-card label { font-size: var(--fs); color:#222; white-space: nowrap; }
  .filters-card .sep { text-align: center; color:#666; font-size: var(--fs-small); }
  
  .filters-card input[type="text"],
  .filters-card input[type="date"],
  .filters-card select{
    height: var(--h);
    padding: 0 var(--pad-x);
    border: 1px solid #d5d5d5;
    border-radius: var(--radius);
    font-size: var(--fs);
    outline: none; width: 100%;
  }
  .filters-card input:focus, .filters-card select:focus{
    border-color:#b3b3b3;
    box-shadow:0 0 0 3px rgba(255,196,52,.22);
  }
  
  /* Helpers */
  .filters-card .span-3 { grid-column: 2 / -1; }
  .filters-card .cell{ height:0; }
  .filters-card .span-4{ grid-column: 1 / -1; }
  .grayed-out{ background:#f5f5f5; color:#999; }
  
  /* Button */
  .btn-submit-save{
    padding: 10px 14px; font-size: .95rem; border-radius: 10px;
    background:#FFC434; border:none; cursor:pointer; font-weight:600;
    box-shadow:0 2px 6px rgba(0,0,0,.08);
  }
  .btn-submit-save:hover{ background:#e6b12e; }
  
  /* Responsive */
  @media (max-width: 1200px){
    .filters-card { --ctrl-w: 300px; }
  }
  @media (max-width: 980px){
    .filters-card { --label-w: 150px; --ctrl-w: 1fr; }
    .filters-card .row { grid-template-columns: var(--label-w) 1fr; }
    .filters-card .sep, .filters-card .row > .cell { display: none; }
  }
  </style>
  
  <script>
  import axios from 'axios';
  import Swal from 'sweetalert2';
import { showReportLoading, hideReportLoading } from '@/utils/reportLoading';
  
  export default {
    data() {
      return {
        startDate: '',
        endDate: '',
        noteNumberStart: '',
        noteNumberEnd: '',
        noteType: '',
        operatorNumberStart: '',
        operatorNumberEnd: '',
        operatorName: '',
        blockEdit: false,
        isGeneratingReport: false,
      };
    },
  
    computed: {
      effectiveEndDate() {
        return this.endDate || this.startDate;
      },
    },
  
    methods: {
      formatToDatetime(date, time) {
        if (!date) return '';
        return `${date}T${time}`;
      },
      backMainPanel() {
        window.location.href = '/main-panel';
      },
  
      validateNoteNumbers() {
        if (this.noteNumberStart !== '' && this.noteNumberEnd === '') {
          Swal.fire({ icon:'error', title:'Error de validación', text:'Debe ingresar un número de orden final cuando ingresa un número inicial' });
          return false;
        }
        if (this.noteNumberStart === '' && this.noteNumberEnd !== '') {
          Swal.fire({ icon:'error', title:'Error de validación', text:'No puede ingresar un número de orden final sin un número inicial' });
          return false;
        }
        if (this.noteNumberStart !== '' && this.noteNumberEnd !== '') {
          const a = parseInt(this.noteNumberStart, 10);
          const b = parseInt(this.noteNumberEnd, 10);
          if (Number.isFinite(a) && Number.isFinite(b) && b < a) {
            Swal.fire({ icon:'error', title:'Error de validación', text:'El número de orden final debe ser mayor o igual al número de orden inicial' });
            return false;
          }
        }
        return true;
      },
  
      validateOperatorNumbers() {
        if (this.operatorNumberStart !== '' && this.operatorNumberEnd === '') {
          Swal.fire({ icon:'error', title:'Error de validación', text:'Debe ingresar un número de operador final cuando ingresa un número inicial' });
          return false;
        }
        if (this.operatorNumberStart === '' && this.operatorNumberEnd !== '') {
          Swal.fire({ icon:'error', title:'Error de validación', text:'No puede ingresar un número de operador final sin un número inicial' });
          return false;
        }
        if (this.operatorNumberStart !== '' && this.operatorNumberEnd !== '') {
          const a = parseInt(this.operatorNumberStart, 10);
          const b = parseInt(this.operatorNumberEnd, 10);
          if (Number.isFinite(a) && Number.isFinite(b) && b < a) {
            Swal.fire({ icon:'error', title:'Error de validación', text:'El número de operador final debe ser mayor o igual al número inicial' });
            return false;
          }
        }
        return true;
      },
  
      async generateReport() {
        if (this.isGeneratingReport) return;
        // Stop if ANY validation fails
        if (![this.validateNoteNumbers(), this.validateOperatorNumbers()].every(Boolean)) return;
  
        const payload = {
          start_date: this.formatToDatetime(this.startDate, '00:00'),
          end_date: this.formatToDatetime(this.effectiveEndDate, '23:59'),
          note_number_start: this.noteNumberStart,
          note_number_end: this.noteNumberEnd,
          note_type: this.noteType,
          operator_name: this.operatorName,
          operator_number_start: this.operatorNumberStart,
          operator_number_end: this.operatorNumberEnd,
        };
  
        this.isGeneratingReport = true;
        showReportLoading();

        try {
          const apiDirectory = process.env.API_DIRECTORY;
          const response = await axios.post(`${apiDirectory}/reports/report-operator-commission`, payload, {
            responseType: 'blob',
          });
  
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'reporte_comisiones_de_operador.zip');
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
        } catch (error) {
          const errorMessage = error?.response?.data?.error || error.message;
          Swal.fire({ icon: 'error', title: 'Error Generando Reporte', text: errorMessage });
        } finally {
          this.isGeneratingReport = false;
          hideReportLoading();
        }
      },
  
      handleSubmit() {
        this.generateReport();
      },
    },
  };
  </script>
  